import { useBillingRepository } from '@Hooks/useRepository';
import { type InvoiceCancellationOptions } from '@Model';
import { InvoicesRepository } from '@Repositories/Billing';
import { isOk, useToasts } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useClientNavigate } from '../../Routing/useClientNavigate';

export function useCancelInvoice() {
    const navigate = useClientNavigate();
    const { pushAllToasts } = useToasts();
    const invoices = useBillingRepository(InvoicesRepository);

    const { mutateAsync: cancelMutation } = useMutation({
        mutationFn: (options: InvoiceCancellationOptions) => invoices.cancelInvoice(options),
    });

    return useCallback(
        async (invoiceId: string, reason: string) => {
            const result = await cancelMutation({
                invoice_id: invoiceId,
                cancellation_reason: reason,
            });

            if (isOk(result)) {
                const cancellation = result.data;
                navigate(`/billing/invoices/${cancellation.id}`);
            } else {
                pushAllToasts(result.messages);
            }
        },
        [cancelMutation, navigate, pushAllToasts],
    );
}
